<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <label for="password" class="col-md-3">Mot de passe actuel:</label>
          <input
            v-model="current_password"
            type="password"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !current_password }"
            id="password"
            placeholder="Votre mot de passe actuel"
            name="password"
          />
        </div>

        <div class="form-group row">
          <label for="password" class="col-md-3">Nouveau mot de passe:</label>
          <input
            v-model="new_password"
            type="password"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && (!new_password || !samePassword)}"
            id="new_password"
            placeholder="Nouveau mot de passe"
            name="new_password"
          />
        </div>

        <div class="form-group row">
          <label for="password_confirmation" class="col-md-3">
            Confirmation:</label
          >
          <input
            v-model="confirm_newpassword"
            type="password"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && (!confirm_newpassword || !samePassword)}"
            id="password_confirmation"
            placeholder="Confirmation"
            name="password_confirmation"
          />
        </div>

        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="col-md-8">
            <button type="submit" class="btn btn-primary">Valider</button>
            <router-link
              class="btn btn-dark action-btn-cancel"
              :to="{ name: 'users' }"
            >
              Retourner
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
// import { mapGetters } from "vuex";

import { CHANGE_PASSWORD } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";

export default {
  name: "ChangePasswordForm",
  data() {
    return {
      current_password: "",
      new_password: "",
      confirm_newpassword: "",
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
      errors: {},
    };
  },
  async mounted() {},
  computed: {},
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;

      this.submitted = true;

      const { current_password, new_password, confirm_newpassword } = this;

      if (!current_password || !new_password || !confirm_newpassword) {
        return;
      }

      // check passwords
      if(!this.samePasswords(new_password, confirm_newpassword)){
        this.samePassword = false;
        return;
      }else{
        this.samePassword = true;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(CHANGE_PASSWORD, {
          current_password,
          new_password,
          confirm_newpassword,
        })
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;
          this.message.error = false;

          //On réinitialise l'état
          this.current_password = "";
          this.new_password = "";
          this.confirm_newpassword = "";

          this.submitted = false;
        })
        .catch((error) => {
          this.errors = error.errors;
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    samePasswords(password, password_confirmation){
      return password === password_confirmation;
    },
  },
};
</script>